import content from 'pp-react-l10n'
import { isEmpty, find } from 'lodash'

let i18n = content('transfer/inc/cashAdvanceFees')

// this function is used to correctly return the warning label used when there is
// a cash advance fee that may applied to a funding instrument
export function getCashAdvanceWarningContent(
  pContent,
  genericIssuerName = i18n('generic.issuer.name')
) {
  const hasPStudioContent = !isEmpty(pContent)
  const cashAdvanceWarningContent =
    hasPStudioContent && pContent.review_page_in_line_warning
      ? pContent.review_page_in_line_warning
      : `${i18n('warning.label', { genericIssuerName })}`
  const generic_issuer_name =
    genericIssuerName ||
    (hasPStudioContent && pContent.generic_issuer_name
      ? pContent.generic_issuer_name
      : i18n('generic.issuer.name'))

  return cashAdvanceWarningContent.replace('{{issuer}}', generic_issuer_name)
}

export function getTheFundingSourceWithCashAdvanceFee(funding_sources = []) {
  const numFundingSources = funding_sources.length
  let funding_source = {}
  if (numFundingSources > 1) {
    funding_source = find(funding_sources, { cashAdvanceFeeApplies: true })
  } else if (numFundingSources === 1) {
    funding_source = funding_sources[0]
  }
  return funding_source
}
